import type { CSSProperties } from "react";
import { resolveAssetPath } from "../../shared/utilities/assets";
import type { SectionRenderProps } from "../renderer/types";

export function EventsSection({ data, config, copy }: SectionRenderProps) {
  const photoBreak = String(config.settings.photoBreak || "");
  return (
    <>
      <section className="details section-inner" id="events">
        <div className="section-heading">
          <p className="eyebrow">{copy.saveDate}</p>
          <h2>{copy.events}</h2>
        </div>
        <div className="detail-grid">
          {data.events.slice().sort((a, b) => a.order - b.order).map((event, index) => {
            const eventIndex = data.events.findIndex((item) => item.id === event.id);
            return <article className="detail-card" key={event.id} data-editor-section="events" data-editor-field={`events.${eventIndex}`}>
              <span className="detail-icon">{String(index + 1).padStart(2, "0")}</span>
              <h3 data-editor-section="events" data-editor-field={`events.${eventIndex}.title`}>{event.title}</h3>
              <p>{event.date || "Date not set"}<br />{[event.startTime, event.endTime].filter(Boolean).join(" - ")}</p>
              <small>{event.venueName}<br />{event.address}</small>
              {event.additionalInformation ? <p data-editor-section="events" data-editor-field={`events.${eventIndex}.additionalInformation`}>{event.additionalInformation}</p> : null}
              {event.mapsUrl ? <a href={event.mapsUrl} target="_blank" rel="noreferrer">{copy.maps}</a> : null}
            </article>;
          })}
        </div>
      </section>
      {photoBreak ? (
        <section className="photo-break" style={{ "--photo": `url("${resolveAssetPath(photoBreak)}")` } as CSSProperties}>
          <img src={resolveAssetPath(photoBreak)} alt={data.invitation.title} />
        </section>
      ) : null}
    </>
  );
}
